import { ICompanyState, CompanyActions } from "./company.interface";

const initialState: ICompanyState = {
  id: 0,
  name: "",
  alias: "",
  cleanable: false,
  connected: false
};
export interface Action{type: CompanyActions, payload: {
  company: ICompanyState;
}}

export const companyReducer = (state: ICompanyState = initialState, action: Action):ICompanyState => {
  switch (action.type) {
    case CompanyActions.SET_COMPANY:
      return {...state, ...action.payload.company};
    case CompanyActions.CLEAR_COMPANY:
      return {...initialState}
    default:
      return state;
  }
}